module.exports = __webpack_public_path__ + "img/still (33).6598a6a1.jpg";